import { Edge, Node, ClusterNode, Layout } from '@swimlane/ngx-graph';

export class MasterConfig {
    nodeboxtypes: NodeBoxType[];
    farmtypes: FarmType[];
    transformers: Transformers[];
    
    
    static fromJSON(data: any): MasterConfig {
        ////console.log(`fromJson invoked: ${data}`);
        const config: MasterConfig = Object.assign(new MasterConfig(), data);

        const nodeboxtypes: NodeBoxType[] = [];
        config.nodeboxtypes.forEach(node => {
            const nod = node;//Node.fromJSON(node);
            nodeboxtypes.push(nod);
        });
        config.nodeboxtypes = nodeboxtypes;

        // Transforms
        const farmtypes: FarmType[] = [];
        config.farmtypes.forEach(farm => {
            //links.push(dataRefineryConfig.deserializeTransform(t));
            const frm = farm;//Node.fromJSON(node);
            //transformers: Transformers[];
            farmtypes.push(frm);
        });
        config.farmtypes = farmtypes;
        return config;
    }

    // public static deserializeTransform(t: DataTransform<any>): DataTransform<any> {
    //     switch (t.transformType) {
    //         case TransformType.activityNamer:
    //             return  ActivityNamingTransform.fromJSON(t);
    //         case TransformType.rowExtractor:
    //             return RowExtractorTransform.fromJSON(t);
    //         case TransformType.eventNamer:
    //             return EventNamerTransform.fromJSON(t);
    //         case TransformType.eventGroupNamer:
    //             return EventGroupNamerTransform.fromJSON(t);
    //         case TransformType.groupAttributo1r:
    //             return GroupAttributo1rTransform.fromJSON(t);
    //         case TransformType.columnCalc:
    //             return ColumnCalcTransform.fromJSON(t);
    //         default:
    //             throw new Error('Unsupported transform type: ' + t.transformType.toString());
    //     }
    // }
}
export class NodeBoxType {
    id: number;
    nodetype: string;
}
  
export class FarmType {
    id: number;
    nodeboxtypeid: number;
    farmtype: string;
    color: string;
    iconpath: string;
    ingesticonpath: string;
    processoriconpath:string;
    restricttransformers:RestrictTransformers[];
}
export class Transformers {
    id: number;
    transformer: string;
    aboutlink: string;
    globalstat: boolean;
    transformiconpath: string;
    parameters:ParametersSettings[]
}
export class RestrictTransformers {
    transformerid: number;
    allowed: boolean;
}
export class ParameterSetting {
    label:string="";
    jsonobject: string="";
    default: string="";
    isfillrules: boolean=false;
    isrequired: boolean=false;
    iscommonparam: boolean=true;
    isruledefault: boolean=false;
    min: number=0;
    max: number=0;
    isselectblank: boolean=false;
    isvisible: boolean=true;
}
export class ParametersSettings {
    farmtypeid:number;
    parameters:ParameterSetting[];
    rules:RuleSetting[];
}
export class RuleSetting {
    label:string;
    jsonobject: string;
    default: string;
    isrequired: boolean;
    isselectblank: boolean;
    iscontaintext: boolean;
    fieldType: string;
    isvisible: boolean;
}
